import React, { Component } from 'react'

import Header from '../Header'
import Modal from '../../../../atoms/Modal'
import Loading from '../../../../atoms/Loading'

// import * as timeline from '../../../../utils/timeline'

import style from './style.css'
import global from '../style.css'
export default class Boxtext extends Component {

    state = {
        show: false,
        status: 'loading',
        data: {}
    }

    handleShow() {
        this.props.openArticle(this.props.data.token)
        // this.setState({
        //     show: true
        // })
        // timeline.loadPost(this.props.data.id)
        // .then(resp => {
        //     this.setState({
        //         status: 'done',
        //         data: resp
        //     })
        // })
    }

    render() {
        let data = this.props.data
        let content = JSON.parse(data.content)
        return(
            <div className={`${global.box} ${ this.props.needApprove ? global.needApprove : '' }`}>
                <Header
                    is_admin={this.props.is_admin}
                    data={data}
                    needApprove={this.props.needApprove}
                    actionDelete={(id) => this.props.handleDelete(id) }
                    onApprove={() => this.props.onApprove()}
                    actionEdit={(id) => this.props.handleEdit(id) }/>
                <div>
                    <div
                    onClick={() => { this.handleShow() }}
                    className={`${style.content} ${style.pointer}`}>
                        <div className={style.title} style={{fontSize: '21px', lineHeight: '30px'}}>
                            {content.title}
                        </div>
                        <span style={{fontSize: '15px', lineHeight: '1.2'}} dangerouslySetInnerHTML={{ __html: content.content }} />
                    </div>

                    {this.props.children}
                </div>


                <Modal
                    active={this.state.show}
                    full
                    style={{width: '100%' }}
                    handleClose={() => {
                        this.setState({
                            show: false
                        })
                    }}>
                    {this.state.status === 'loading' && (
                        <Loading />
                    )}
                    {this.state.status === 'done' && (
                        <div>
                            <div className={`${style.content} ${style.contentBlack}`} style={{textAlign: 'center'}}>
                                <div className={style.title}>
                                    {JSON.parse(this.state.data.content).title}
                                </div>
                                <div  style={{
                                            width: '100%',
                                            maxWidth: '700px',
                                            textAlign: 'left',
                                            margin: '0 auto',
                                        }} dangerouslySetInnerHTML={{__html: this.state.data.long_content}}></div>
                            </div>
                        </div>
                    )}
                </Modal>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/SPRINTA/organisms/Timeline/Containers/BoxArticle/index.js